export default function lessThanToText() {
    return function (input) {
        if (input) {
            if (input.indexOf('<') === 0) {
                return input.replace('<', 'less than ');
            }
        }

        return input;
    }
};